import api from '@/api';
import { API_BASE_URL } from '..';
import {
  CreateNfsInstallment,
  InstallmentEditRequest,
  NfsInstallments,
  UpdateNfsInstallment,
} from './Installment.types';

const CONTROLLER_URL = `${API_BASE_URL}/invoices`;

export async function nfsInstallments(invoiceId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${invoiceId}/nfs-installments`,
    null,
  )) as unknown;

  return result as NfsInstallments[];
}

export async function nfsEditInstallment(obj: InstallmentEditRequest) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${obj.invoiceId}/nfs-installments/${obj.id}`,
    null,
  )) as unknown;

  return result as NfsInstallments;
}

export async function createNfsInstallment(obj: CreateNfsInstallment) {
  const { invoiceId, ...values } = obj;

  const result = (await api.post(
    `${CONTROLLER_URL}/${invoiceId}/nfs-installments`,
    values,
    null,
  )) as unknown;

  return result;
}

export async function updateNfsInstallment(obj: UpdateNfsInstallment) {
  const { invoiceId, id, ...values } = obj;

  const result = (await api.put(
    `${CONTROLLER_URL}/${invoiceId}/nfs-installments/${id}`,
    values,
    null,
  )) as unknown;

  return result;
}

export async function deleteNfsInstallment(obj: InstallmentEditRequest) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${obj.invoiceId}/nfs-installments/${obj.id}`,
    {},
    null,
  )) as unknown;

  return result;
}
